jQuery(document).ready(function () {
	jQuery(".jsOffcanvasMenuToggler").on("click", function () {
		return (
			jQuery(this).toggleClass("open"),
			jQuery(".jsOffcanvasMenu").toggleClass("open"),
			jQuery("body").toggleClass("menu-open"),
			!1
		);
	});
});
